module.exports = __webpack_public_path__ + "img/rasterized-gradient-blue-500.e91860d.png";